"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepThreeOnlineAppointment = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../../atome");
const OnlineAppointment_style_1 = require("../OnlineAppointment.style");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const InputLoader_1 = __importDefault(require("../../../../atome/InputLoader/InputLoader"));
const User_service_1 = __importDefault(require("../../../../../services/User.service"));
// @ts-ignore
function StepThreeOnlineAppointment({ isSaving, selectedSlot, bookAppointment, assignedDoctor, setAssignedDoctor, }) {
    (0, react_1.useEffect)(() => {
        const getDoctor = async () => {
            const doctor = await User_service_1.default.getDoctor(parseInt(selectedSlot.doctorId));
            setAssignedDoctor(doctor.data);
        };
        getDoctor();
    }, []);
    return (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
        react_1.default.createElement(react_native_1.ScrollView, { style: OnlineAppointment_style_1.styles.whiteBackground },
            react_1.default.createElement(react_native_1.View, { style: [OnlineAppointment_style_1.styles.container] },
                react_1.default.createElement(react_native_1.View, { style: [
                        GlobalStyles_1.globalStyles.marginBottom40,
                        GlobalStyles_1.globalStyles.marginHorizontal35,
                        GlobalStyles_1.globalStyles.marginTop35,
                    ] },
                    react_1.default.createElement(atome_1.Label, { style: [OnlineAppointment_style_1.styles.lineHeight20] }, "Bitte pr\u00FCfen Sie abschlie\u00DFend Ihre Angeaben und buchen Sie Ihren Termin mit \"Jetzt buchen\".")),
                react_1.default.createElement(react_native_1.View, { style: [
                        GlobalStyles_1.globalStyles.row,
                        OnlineAppointment_style_1.styles.selectedAppointmentContainer,
                        GlobalStyles_1.globalStyles.marginTop5,
                    ] },
                    react_1.default.createElement(react_native_1.View, { style: [OnlineAppointment_style_1.styles.positionRelative, OnlineAppointment_style_1.styles.calendarIconContainer] },
                        react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: 80, color: '#3db384' }),
                        react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_style_1.styles.selectedDateDay] }, selectedSlot
                            ? new Date(selectedSlot.start)
                                .getDate()
                                .toLocaleString('de-DE', {
                                minimumIntegerDigits: 2,
                            })
                            : ' ?')),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.column,
                            GlobalStyles_1.globalStyles.marginTop30,
                            GlobalStyles_1.globalStyles.marginLeft20,
                            OnlineAppointment_style_1.styles.selectedAppointmentWrapper,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_style_1.styles.heading2, OnlineAppointment_style_1.styles.selectedAppointmentHeader] }, "Ihre Videosprechstunde"),
                        react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_style_1.styles.colorBlack] }, "Datum / Uhrzeit:"),
                        react_1.default.createElement(atome_1.Text, { style: [
                                OnlineAppointment_style_1.styles.colorBlack,
                                GlobalStyles_1.globalStyles.marginTop5,
                                OnlineAppointment_style_1.styles.textBold,
                            ] }, selectedSlot
                            ? new Date(selectedSlot.start).toLocaleString('de-DE', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                            }) + ' Uhr'
                            : ' '),
                        react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.marginTop20 },
                            react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_style_1.styles.colorBlack] }, "Arzt / \u00C4rztin:"),
                            react_1.default.createElement(atome_1.Text, { style: [
                                    OnlineAppointment_style_1.styles.colorBlack,
                                    GlobalStyles_1.globalStyles.marginTop5,
                                    OnlineAppointment_style_1.styles.textBold,
                                ] },
                                assignedDoctor && assignedDoctor?.doctor.title
                                    ? assignedDoctor?.doctor.title === 'doctor'
                                        ? 'Dr.'
                                        : assignedDoctor?.doctor.title === 'professor'
                                            ? 'Prof.'
                                            : ''
                                    : '',
                                assignedDoctor && assignedDoctor?.doctor.firstname,
                                " ",
                                assignedDoctor && assignedDoctor?.doctor.lastname)))),
                react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, OnlineAppointment_style_1.styles.buttonContainer] },
                    react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                            isSaving ? OnlineAppointment_style_1.styles.buttonLoading : OnlineAppointment_style_1.styles.button,
                            GlobalStyles_1.globalStyles.saveButtonContainer,
                        ], onPress: bookAppointment },
                        isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                        react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_style_1.styles.buttonText] }, "Jetzt buchen")))))));
}
exports.StepThreeOnlineAppointment = StepThreeOnlineAppointment;
